import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";

class ngTextArea extends ngEditableEx
{
	#target;
	
	constructor () {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {
		this.shadowRoot.innerHTML = `
			<textarea ondragstart="return false"></textarea>
		`;
		
		super.connectedCallback();
		
		if (!this.owner) return;
		
		this.#target = this.shadowRoot.querySelector("textarea");

		if (!this.owner.shadowRoot.querySelector("ng-textarea-detail")) $(this.owner.shadowRoot).append($('<ng-textarea-detail></ng-textarea-detail>'));

		if (!this.cell.getAttribute("onButtonClick") && !this.getAttribute("onButtonClick")) {
			const expandButton = this.shadowRoot.querySelector("ng-expand-button");
			if (expandButton) {
				$("button", expandButton.shadowRoot).on("click", e => {
					this.owner.shadowRoot.querySelector("ng-textarea-detail").popup(this.cell.dataset.row, this.cell.dataset.bind, $(this.#target).val());
				});
			}
		}
		
		$(this.cell).on("keydown", e => {
				
			switch (e.target.tagName) {
			case "TH": case "TD":
				if (["Enter"].includes(e.code)) {
					this.#target.focus();
					this.#target.select();
				}
				break;
			}
		});

		/**
		 * jquery는 e.isComposing 미지원
		 */
		this.#target.addEventListener("keydown", e => {
			if (e.isComposing || e.keyCode === 229) return;
			
			if (["Escape"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
			}
			else if (["Tab","PageUp","PageDown"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
				this.owner.cell.moveCell(e);
			}
		});
	};
	
	dataRefresh = (v) => {
		$(this.#target).val(this.value);
		
		if (!v) this.reset();
	};
}


class ngTextAreaDetail extends HTMLElement
{
	#owner;
	#row;
	#bind;
	#originValue;
	
	constructor() {
	
		super();
		
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");
		
		this.shadowRoot.innerHTML = `
			<style>
				textarea {
					width: 100%;
					height: 100%;
					box-sizing: border-box;
					border: 1px solid #ccc;
					border-radius: 3px;
					resize: none;
					font: inherit;
				}
				
				textarea:focus {
					outline: 0;
				}
			</style>
			
			<nx-dialog>
				<textarea></textarea>
			</nx-dialog>
		`;

		$(".reset", this.shadowRoot).on("click", e => {
			$("textarea", this.shadowRoot).val(this.#originValue);
		});
		
		$(".apply", this.shadowRoot).on("click", e => {
			this.#owner.data.setValue(this.#row, this.#bind, $("textarea", this.shadowRoot).val());
			this.shadowRoot.querySelector('dialog').close();
		});
	}
	
	popup = (row, bind, v) => {
		
		this.#row = row;
		this.#bind = bind;
		this.#originValue = v;

		$("textarea", this.shadowRoot).val(v);
		
		this.shadowRoot.querySelector('nx-dialog').showModal();
	};
}

if (!customElements.get('ng-textarea')) {
	customElements.define("ng-textarea", ngTextArea);
}

if (!customElements.get('ng-textarea-detail')) {
	customElements.define("ng-textarea-detail", ngTextAreaDetail);
}
